import { render } from "./SealSetting.vue?vue&type=template&id=273730ca&scoped=true"
import script from "./SealSetting.vue?vue&type=script&lang=js"
export * from "./SealSetting.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273730ca"]])

export default __exports__